import { useEffect, useState } from 'react';
import api from '../../services/api';
import useAuth from '../useAuth.js';

const useMessages = ({ whatsappId } = {}) => {
    const [messages, setMessages] = useState({ sent: 0, received: 0 });
    const [loading, setLoading] = useState(true);
    const { user } = useAuth();

    useEffect(() => {
        const fetchMessages = async () => {
            try {
                const params = new URLSearchParams();
                if (whatsappId) {
                    params.set('whatsappId', whatsappId);
                } else if (user?.profile !== 'admin' && user?.id) {
                    params.set('userId', user.id);
                }
                const query = params.toString() ? `?${params.toString()}` : '';
                const { data } = await api.get(`/messages/count${query}`);
                if (Array.isArray(data) && data.length > 0) {
                    const messageCount = data[0];
                    setMessages({
                        sent: messageCount.send || 0,
                        received: messageCount.receive || 0
                    });
                }
            } catch (err) {
                console.error(err);
                setMessages({ sent: 0, received: 0 });
            }
            setLoading(false);
        };

        fetchMessages();
    }, [user, whatsappId]);

    return { ...messages, loading };
};

export default useMessages;
